module.exports = __webpack_public_path__ + "static/media/1.db9c676a.png";